import React, { useState } from "react";
import Layout from "../form-layout";

const OPTIONS = ["Less than 4 weeks", "4-8 weeks", "8-12 weeks", "More than 12 weeks"];

// Form B Q4 — "How long have you been taking your current dose?"
export default function DoseDuration({ formData, setFormData, onBack, goToStep }) {
  const [duration, setDuration] = useState(formData.doseDuration || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!duration) return;

    setFormData((prev) => ({ ...prev, doseDuration: duration }));
    localStorage.setItem("doseDuration", duration);

    goToStep("b5");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        How long have you been taking your current dose?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {OPTIONS.map((option) => (
          <label key={option} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="doseDuration"
              checked={duration === option}
              onChange={() => setDuration(option)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option}</span>
          </label>
        ))}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={!duration}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!duration ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
